import React from 'react'
import { FormattedMessage } from 'react-intl'

export const LANDING_PROMO_HEADER = (
    <FormattedMessage
        id='landing_promo.header'
        defaultMessage='КЛАНЫ В WORLD OF TANKS'
    />
)

export const LANDING_PROMO_MESSAGE = (
    <FormattedMessage
        id='landing_promo.message'
        // eslint-disable-next-line max-len
        defaultMessage={'Вступайте в клан, играйте вместе с другими танкистами, достигайте общих целей и получайте технику, золото, боны и клановые резервы для ускорения развития в игре!'}
    />
)

export const LANDING_PROMO_REWARD = (
    <FormattedMessage
        id='landing_promo.reward'
        defaultMessage={'Награда за вступление:{brTag} Стиль для клановых игроков'}
        values={{
            brTag: <br/>,
        }}
    />
)



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingPromo/translations.jsx